import Rectangle from "./Rectangle";
import IsoscelesTriangle from "./IsoscelesTriangle";
import Length from "./Length";
import AbstractShape from "./AbstractShape";

export default class Arrow extends AbstractShape {
	static NAME = "arrow";

	constructor( stem_length, stem_width, head_length, head_width ) {
		super();

		this.stem_length = stem_length;
		this.stem_width = stem_width;
		this.head_length = head_length;
		this.head_width = head_width;
	}

	get_name() {
		return Arrow.NAME;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.stem_length.add( this.head_length ), this.stem_width.max( this.head_width ) );
	}

	get_area() {
		const stem_area = new Rectangle( this.stem_length, this.stem_width ).get_area();
		const head_area = new IsoscelesTriangle( this.head_width, this.head_length ).get_area();
		return stem_area.add( head_area );
	}

	get_circumference() //When using the simple shapes we over count the circumference, so subtract the shared line twice.
	{
		const stem_circumference   = new Rectangle( this.stem_length, this.stem_width ).get_circumference();
		const head_circumference   = new IsoscelesTriangle( this.head_width, this.head_length ).get_circumference();
		const shared_circumference = this.stem_width.min( this.head_width );
		return stem_circumference.add( head_circumference ).subtract( shared_circumference ).subtract( shared_circumference );
	}

	get_stem_length() {
		return this.stem_length;
	}

	get_stem_width() {
		return this.stem_width;
	}

	get_head_length() {
		return this.head_length;
	}

	get_head_width() {
		return this.head_width;
	}

	get_maximum_dimensions() {
		return {};
	}

	get_dimension_keys() {
		return [ "stem_length", "stem_width", "head_length", "head_width" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			stem_length: this.stem_length.in_mm(),
			stem_width: this.stem_width.in_mm(),
			head_length: this.head_length.in_mm(),
			head_width: this.head_width.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new Arrow( new Length( primitives.stem_length ), new Length( primitives.stem_width ), new Length( primitives.head_length ), new Length( primitives.head_width ) );
	}

}
